<div [ngSwitch]="view" class="views">
    <chat-chats-sidenav class="view"
                        *ngSwitchCase="'chats'"
                        [@slideInRight]>
    </chat-chats-sidenav>
</div>
